<template>
  <div>
    <b-container fluid>
      <b-card no-body>
        <b-overlay
          :show="isLoading"
          rounded="sm"
        >
          <div class="m-2">
            <b-form>
              <b-row>
                <b-col
                  sm="12"
                  md="6"
                  lg="6"
                  xl="3"
                >
                  <b-form-group
                    label="Hệ đào tạo"
                    label-for="trainingSystem"
                  >
                    <v-select
                      id="trainingSystem"
                      v-model="filter.trainingSystemId"
                      label="name"
                      :options="trainingSystems"
                      :reduce="(option) => option.id"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  sm="12"
                  md="6"
                  lg="6"
                  xl="3"
                >
                  <b-form-group
                    label="Khóa học"
                    label-for="course"
                  >
                    <v-select
                      id="course"
                      v-model="filter.courseId"
                      label="name"
                      :options="courses"
                      :reduce="(option) => option.id"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  sm="12"
                  md="6"
                  lg="6"
                  xl="3"
                >
                  <b-form-group
                    label="Học kỳ"
                    label-for="semester"
                  >
                    <v-select
                      id="semester"
                      v-model="filter.courseSemesterId"
                      label="name"
                      :options="semesters"
                      :reduce="(option) => option.id"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  sm="12"
                  md="6"
                  lg="6"
                  xl="3"
                >
                  <b-form-group
                    label="Môn học"
                    label-for="subject"
                  >
                    <v-select
                      id="subject"
                      v-model="filter.subjectId"
                      label="name"
                      :options="subjects"
                      :reduce="(option) => option.id"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <div class="w-100 d-flex justify-content-center">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="primary"
                      class="mr-1"
                      @click="getExaminationRoomsFromStore"
                    >
                      <span class="text-nowrap text-right">
                        <feather-icon icon="SearchIcon" /> Tìm kiếm
                      </span>
                    </b-button>

                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="secondary"
                      class="mr-1"
                      @click="onResetFilter"
                    >
                      <span class="text-nowrap text-right">
                        <feather-icon icon="RefreshCcwIcon" /> Đặt lại
                      </span>
                    </b-button>

                    <b-button
                      v-if="scoreLockUpdatable"
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      v-b-modal.inputPasswordModal
                      variant="success"
                      class="mr-1"
                    >
                      <span class="text-nowrap text-right">
                        <feather-icon icon="CheckIcon" /> Lưu khóa
                      </span>
                    </b-button>
                  </div>
                </b-col>
              </b-row>
            </b-form>
            <b-row class="mt-2">
              <b-col cols="12">
                <vue-good-table
                  mode="remote"
                  :columns="columns"
                  :rows="examinationRooms"
                  :pagination-options="paginationOptions"
                  :total-rows="totalRows"
                  :line-numbers="true"
                  @on-page-change="onPageChange"
                  @on-sort-change="onSortChange"
                  @on-column-filter="onColumnFilter"
                  @on-per-page-change="onPerPageChange"
                >
                  <div
                    slot="emptystate"
                    style="text-align: center; font-weight: bold"
                  >
                    Không có bản ghi nào !
                  </div>
                  <template
                    slot="table-column"
                    slot-scope="props"
                  >
                    <span v-if="props.column.label === 'Khóa điểm'">
                      <div
                        class="d-flex align-items-center justify-content-center"
                      >
                        <b-form-checkbox
                          v-model="selectedAll"
                          :value="1"
                          :unchecked-value="0"
                        />
                      </div>
                    </span>
                    <span v-else>
                      {{ props.column.label }}
                    </span>
                  </template>

                  <template
                    slot="table-row"
                    slot-scope="props"
                  >
                    <span v-if="props.column.field === 'scoreLock'">
                      <div
                        class="d-flex align-items-center justify-content-center"
                      >
                        <b-form-checkbox
                          v-model="props.row.scoreLock"
                          :value="1"
                          :unchecked-value="0"
                          @change="
                            changeLock(
                              props.row.scoreLock,
                              props.column.field,
                              props.row.originalIndex
                            )
                          "
                        />
                      </div>
                    </span>

                    <!-- Column: Common -->
                    <span v-else>{{
                      props.formattedRow[props.column.field]
                    }}</span>
                  </template>

                  <!-- pagination -->
                  <template
                    slot="pagination-bottom"
                    slot-scope="props"
                  >
                    <div class="d-flex justify-content-between flex-wrap">
                      <div class="d-flex align-items-center mb-0 mt-1">
                        <span class="text-nowrap"> Hiển thị 1 đến </span>
                        <b-form-select
                          v-model="filter.itemsPerPage"
                          :options="itemsPerPageOptions"
                          class="mx-1"
                          @input="
                            (value) =>
                              props.perPageChanged({ currentPerPage: value })
                          "
                        />
                        <span
                          class="text-nowrap"
                        >của {{ examinationRooms.length }} bản ghi</span>
                      </div>
                      <div>
                        <b-pagination
                          :value="1"
                          :total-rows="totalRows"
                          :per-page="filter.itemsPerPage"
                          class="mt-1 mb-0"
                          @input="
                            (value) => props.pageChanged({ currentPage: value })
                          "
                        />
                      </div>
                    </div>
                  </template>
                </vue-good-table>
              </b-col>
            </b-row>
          </div>
        </b-overlay>
      </b-card>
    </b-container>

    <InputPassword @succeed="onSaveLockScore" />
  </div>
</template>

<script>
import Ripple from 'vue-ripple-directive'
import {
  BButton,
  BCard,
  BCol,
  BContainer,
  BFormSelect,
  BOverlay,
  BPagination,
  BRow,
  BForm,
  BFormGroup,
  BFormCheckbox,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import '@core/scss/vue/libs/vue-good-table.scss'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { getUser } from '@/auth/utils'
import vSelect from 'vue-select'
import { SCORE_LOCKS } from '@/const/status'
import { hasPermissionForResource, isSystemAdmin } from '@/utils'
import { PermissionCode, ResourceCode } from '@/const/code'
import InputPassword from '@/views/score-lock/InputPassword.vue'

export default {
  name: 'ScoreLockExamination',
  directives: {
    Ripple,
  },
  components: {
    InputPassword,
    BButton,
    BCard,
    BCol,
    BContainer,
    BFormSelect,
    BOverlay,
    BPagination,
    BRow,
    BForm,
    BFormGroup,
    BFormCheckbox,
    VueGoodTable,
    vSelect,
  },
  data() {
    return {
      user: getUser(),
      isLoading: false,
      filter: {
        organizationId: null,
        currentPage: 1,
        itemsPerPage: 10,
        trainingSystemId: null,
        courseId: null,
        courseSemesterId: null,
        subjectId: null,
        examinationRoomName: null,
        subjectName: null,
        scoreLock: null,
        sort: null,
      },
      paginationOptions: {
        enabled: true,
      },
      itemsPerPageOptions: [10, 20, 30, 50, 80, 100],
      columns: [
        {
          label: 'Phòng thi',
          field: 'examinationRoomName',
          filterOptions: {
            enabled: true,
            trigger: 'enter',
            placeholder: 'Nhập phòng thi',
          },
          sortable: true,
          width: '30%',
          thClass: 'text-center',
        },
        {
          label: 'Môn học',
          field: 'subjectName',
          filterOptions: {
            enabled: true,
            trigger: 'enter',
            placeholder: 'Nhập môn học',
          },
          sortable: true,
          width: '15%',
          thClass: 'text-center',
        },
        {
          label: 'Học kỳ',
          field: 'semesterName',
          width: '20%',
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: 'Khóa',
          field: 'courseName',
          width: '15%',
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: 'Hệ đào tạo',
          field: 'trainingSystemName',
          width: '10%',
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: 'Khóa điểm',
          field: 'scoreLock',
          filterOptions: {
            enabled: true,
            trigger: 'enter',
            filterDropdownItems: SCORE_LOCKS,
            placeholder: 'Chọn trạng thái',
          },
          width: '10%',
          sortable: false,
          thClass: 'text-center',
        },
      ],
      originExaminationRooms: [],
      selectedAll: 0,
    }
  },
  computed: {
    ...mapGetters({
      examinationRooms: 'examinationRoom/examinationRooms',
      totalRows: 'examinationRoom/totalRows',
      trainingSystems: 'trainingSystem/trainingSystems',
      courses: 'course/courses',
      semesters: 'semester/semesters',
      subjects: 'subject/subjects',
    }),
    scoreLockUpdatable() {
      return (isSystemAdmin() || hasPermissionForResource(PermissionCode.UPDATE, ResourceCode.SCORE_LOCK_EXAMINATION_ROOM))
        && this.user.scoreLockPassword > 0
    },
  },
  watch: {
    selectedAll(val) {
      let data = []
      if (val === 1) {
        data = this.examinationRooms.map(elm => ({ ...elm, scoreLock: 1 }))
      } else if (val === 0) {
        data = this.examinationRooms.map(elm => ({ ...elm, scoreLock: 0 }))
      } else {
        data = this.examinationRooms
      }
      this.setExaminationRooms({ total: this.totalRows, records: data })
    },
    'filter.trainingSystemId': async function (val) {
      if (val) {
        this.isLoading = true
        try {
          await this.getCoursesByTrainingSystemId({ trainingSystemId: val })
          if (this.courses.length > 0) {
            this.updateParams({ courseId: this.courses[0].id })
          }
        } catch (e) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `[${e.code}] ${e.message}`,
              icon: 'XCircleIcon',
              variant: 'danger',
            },
          })
        } finally {
          this.isLoading = false
        }
      } else {
        this.updateParams({ courseId: null, courseSemesterId: null })
        this.setCourses([])
        this.setSemesters([])
        this.setSubjects([])
      }
    },
    'filter.courseId': async function (val) {
      if (val) {
        this.isLoading = true
        try {
          await this.getSemestersByCourseId({ courseId: val })
          if (this.semesters.length > 0) {
            this.updateParams({ courseSemesterId: this.semesters[0].id })
          }
        } catch (e) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `[${e.code}] ${e.message}`,
              icon: 'XCircleIcon',
              variant: 'danger',
            },
          })
        } finally {
          this.isLoading = false
        }
      } else {
        this.updateParams({ courseSemesterId: null })
        this.setSemesters([])
        this.setSubjects([])
      }
    },
    'filter.courseSemesterId': async function (val) {
      if (val) {
        this.isLoading = true
        try {
          await this.getSubjectsByCourseSemesterId({ courseSemesterId: val })
        } catch (e) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `[${e.code}] ${e.message}`,
              icon: 'XCircleIcon',
              variant: 'danger',
            },
          })
        } finally {
          this.isLoading = false
        }
      } else {
        this.updateParams({ subjectId: null })
        this.setSubjects([])
      }
    },
  },
  async created() {
    this.updateParams({ organizationId: this.user.orgId })
    this.isLoading = true
    try {
      await this.getTrainingSystemsByOrganizationId({
        organizationId: this.user.orgId,
      })
      if (this.trainingSystems.length > 0) {
        this.updateParams({ trainingSystemId: this.trainingSystems[0].id })
      }
    } catch (e) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: `[${e.code}] ${e.message}`,
          icon: 'XCircleIcon',
          variant: 'danger',
        },
      })
    } finally {
      this.isLoading = false
    }
  },
  methods: {
    ...mapMutations({
      setCourses: 'course/SET_COURSES',
      setSemesters: 'semester/SET_SEMESTERS',
      setSubjects: 'subject/SET_SUBJECTS',
      setExaminationRooms: 'examinationRoom/SET_EXAMINATIONROOMS',
    }),
    ...mapActions({
      getScoreLockExaminationRooms:
        'examinationRoom/getScoreLockExaminationRooms',
      getTrainingSystemsByOrganizationId:
        'trainingSystem/getTrainingSystemsByOrganizationId',
      getCoursesByTrainingSystemId: 'course/getCoursesByTrainingSystemId',
      getSemestersByCourseId: 'semester/getSemestersByCourseId',
      getSubjectsByCourseSemesterId: 'subject/getSubjectsByCourseSemesterId',
      updateScoreLockExaminationRooms:
        'examinationRoom/updateScoreLockExaminationRooms',
    }),
    updateParams(newProps) {
      this.filter = { ...this.filter, ...newProps }
    },
    async onPageChange(param) {
      this.updateParams({ currentPage: param.currentPage })
      await this.getExaminationRoomsFromStore()
    },
    async getExaminationRoomsFromStore() {
      this.isLoading = true
      try {
        await this.getScoreLockExaminationRooms(this.filter)
        this.originExaminationRooms = this.examinationRooms.map(elm => ({
          ...elm,
        }))
        this.selectedAll = this.examinationRooms.length > 0 && this.examinationRooms.every(el => el.scoreLock === 1) ? 1 : 2
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `[${e.code}] ${e.message}`,
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.isLoading = false
      }
    },
    async onPerPageChange(param) {
      this.updateParams({ currentPage: 1, itemsPerPage: param.currentPerPage })
      await this.getExaminationRoomsFromStore()
    },
    async onSortChange(param) {
      if (param.length > 0) {
        const { field, type } = param[0]
        if (field === 'examinationRoomName') this.updateParams({ sort: `1_${type}` })
        else this.updateParams({ sort: `2_${type}` })
      }
      await this.getExaminationRoomsFromStore()
    },
    async onColumnFilter(param) {
      const { columnFilters } = param
      if (Object.hasOwn(columnFilters, 'examinationRoomName')) {
        this.updateParams({
          examinationRoomName: columnFilters.examinationRoomName,
        })
      }
      if (Object.hasOwn(columnFilters, 'subjectName')) this.updateParams({ subjectName: columnFilters.subjectName })
      if (Object.hasOwn(columnFilters, 'scoreLock')) this.updateParams({ scoreLock: columnFilters.scoreLock })
      await this.getExaminationRoomsFromStore()
    },
    onResetFilter() {
      this.updateParams({
        trainingSystemId: null,
        courseId: null,
        courseSemesterId: null,
        subjectId: null,
      })
    },
    changeLock(data, column, row) {
      this.examinationRooms[row][column] = data
      if (this.examinationRooms.filter(element => element.scoreLock === 1).length === this.examinationRooms.length) {
        this.selectedAll = 1
      } else {
        this.selectedAll = 2
      }
    },
    async onSaveLockScore(password) {
      const scoreLocks = this.examinationRooms
        .filter(o1 => this.originExaminationRooms.some(
          o2 => o1.examinationRoomId === o2.examinationRoomId
              && o1.scoreLock !== o2.scoreLock,
        ))
        .map(element => ({
          id: element.examinationRoomId,
          isScoreLocked: element.scoreLock,
        }))
      if (scoreLocks.length === 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Vui lòng thay đổi khóa điểm phòng thi',
            icon: 'InfoIcon',
            variant: 'warning',
          },
        })
        return
      }
      this.isLoading = true
      try {
        const { isSuccessful, message } = await this.updateScoreLockExaminationRooms({ password, scoreLocks })
        if (isSuccessful) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: message,
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
          this.$bvModal.hide('inputPasswordModal')
          await this.getExaminationRoomsFromStore()
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: message,
              icon: 'XCircleIcon',
              variant: 'danger',
            },
          })
        }
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `[${e.code}] ${e.message}`,
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
